module.exports = __webpack_public_path__ + "static/media/footeradimas.beede86d.png";